// import 'es6-set';
// import 'react-app-polyfill/ie11';
import 'core-js';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/string/repeat';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';

import 'core-js/fn/number/is-nan';

import 'core-js/fn/set';


// eslint-disable-next-line
Array.prototype.remove = function(element) {
  const index = this.indexOf(element);
  if (index >= 0) {
    this.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/polyfills.js